module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./QuickBuyView.js"));
	}, "QuickBuyView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=QuickBuyView!./src/pages/Shop/Member/TradeManage/QuickBuy/QuickBuyView.js
// module id = 1535
// module chunks = 418